export const tooltipStyles = {
  enabled: true,
  backgroundColor: '#fff',
  titleColor: '#000',
  bodyColor: '#000',
  borderColor: '#ccc',
  borderWidth: 1,
  bodyFont: {
    size: 12,
  },
  padding: 8,
  cornerRadius: 8,
  caretSize: 6,
  displayColors: true,
  boxWidth: 12,
  boxHeight: 12,
};
